import React, { useState, useEffect } from "react";
import ListingTable from "./ListingTable";
import Header from "../../Shared/Components/Header/Header";
import Cards from "../../Shared/Components/Cards/Cards";
import Spinner from "../../Shared/Components/Spinner/Spinner";
import { sessionService } from "../../Shared/Utils/SessionService";
import { CONSTANTS, ICON_DETAILS } from "../../Environments/constants";
import { faTriangleExclamation, faSquare, faCircleArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ServiceUtils } from "../../../src/Shared/Utils/ServiceUtils";
import { alertService } from "../../../src/Shared/Utils/ToasterUtils";
import { DownloadOutlined } from '@ant-design/icons';
import classNames from "classnames";
import moment from "moment";
import SVGIcon from "../../../src/Shared/Components/SVGIcon/SVGIcon";
import TopNav from "../../Shared/Components/Tabs/TabContainer";
import { Col, Row, Affix, DatePicker, Tooltip, Button, Badge, Avatar, Card } from "antd";
import "./ComplaintsListing.scss";
import ComplaintDetails from "../ComplaintDetails/ComplaintDetails";
const { RangePicker } = DatePicker;

const MenuConfig = [
    {
        key: "home",
        value: "Home",
    },
];

export default function ComplaintsListing(props) {
    const { onClickDashboard, selectedEnterprise } = props;
    const [complaintsList, setComplaintsList] = useState();
    const [complaintsStatus, setComplaintsStatus] = useState();
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [selectedItem, setSelectedItem] = useState();
    const [isDownloading, setIsDownloading] = useState();
    const [selectedCard, setSelectedCard] = useState("Received");
    const [calenderValue, setCalenderValue] = useState(null);
    const [statusCount, setStatusCount] = useState({ "success": 0, "warning": 0, "error": 0, "breached": 0 });
    const userDetails = sessionService.getSession("cpcb-user");
    const getSelectedItem = (item) => {
        setSelectedItem(item);
    };
    const onClickBack = () => {
        if (selectedEnterprise.title) {
            onClickDashboard()
        }
    }
    const getStatusCount = (data) => {
        setStatusCount(data)
    }
    const onSelectCard = (value) => {
        setSelectedCard(value);
        fetchComplaintsList(value);
    };
    const getStatusDetails = () => {
        let tempCount = { "success": 0, "warning": 0, "error": 0, "breached": 0 };
        let successItems = [];
        let warningItems = [];
        let errorItems = [];
        let breachedItems = [];
        if (complaintsList?.data.length > 0) {
            complaintsList?.data?.map((item) => {
                let days = moment().diff(moment(item.lodged_on), 'days');
                if (item?.sla_breached) {
                    let temp = breachedItems;
                    // let tempCount = statusCount;
                    const isTicketId = temp?.find(t => t === item.ticketId);
                    if (!isTicketId) {
                        temp.push(item.ticketId);
                        tempCount["breached"] = tempCount["breached"] + 1;
                    }
                    setStatusCount(tempCount);
                } else {
                    if (days > 2 && days <= 4) {
                        let temp = warningItems;
                        // let tempCount = statusCount;
                        const isTicketId = temp?.find(t => t === item.ticketId);
                        if (!isTicketId) {
                            temp.push(item.ticketId);
                            tempCount["warning"] = tempCount["warning"] + 1;
                        }
                        setStatusCount(tempCount);
                    } else if (days > 4 && days <= 7) {
                        let temp = errorItems;
                        // let tempCount = statusCount;
                        const isTicketId = temp?.find(t => t === item.ticketId);
                        if (!isTicketId) {
                            temp.push(item.ticketId);
                            tempCount["error"] = tempCount["error"] + 1;
                        }
                        setStatusCount(tempCount);
                    } else {
                        let temp = successItems;
                        // let tempCount = statusCount;
                        const isTicketId = temp?.find(t => t === item.ticketId);
                        if (!isTicketId) {
                            temp.push(item.ticketId);
                            tempCount["success"] = tempCount["success"] + 1;
                        }
                        setStatusCount(tempCount);
                    }
                }
            }
            )
        }
        else {
            setStatusCount(tempCount);
        }
    }
    const statuslist =
        complaintsStatus?.count_json &&
        Object.keys(complaintsStatus?.count_json).filter(
            (item) =>
                item === "open_count" ||
                item === "under_inv_count" ||
                item === "resolved_count"
        );
    useEffect(() => {
        onfetchComplaintsStatus(selectedEnterprise);
        let startDate = moment();
        startDate = startDate.subtract(10, "days");
        startDate = startDate.format("YYYY-MM-DD");
        const endDate = moment().format("YYYY-MM-DD");
        const tempDate = [moment(startDate, "YYYY-MM-DD"), moment(endDate, "YYYY-MM-DD")];
        setCalenderValue(tempDate)
        fetchComplaintsList(selectedCard, [startDate, endDate]);

    }, []);
    useEffect(() => {
        getStatusDetails();
    }, [complaintsList?.data, calenderValue])
    const onClickBreadCrumb = () => {
        if (props.selectedRo) {
            props.onClickStateDashboard()
        } else {
            onClickDashboard()
        }

    }
    let generateFile = (content, fileName) => {
        // let csvContent = atob(content);
        const blob = new Blob([content], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        // const blob = new Blob([content], {type: "text/csv"});
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "complaints_list";
        link.click();
    };
    const onCsvDownload = () => {
        let payload;
        console.log(calenderValue);
        let tempStartDate = null;
        let tempEndDate = null;
        if (calenderValue && calenderValue[1]) {
            tempEndDate = calenderValue[1]["_i"]
            tempStartDate = calenderValue[0]["_i"]
        }
        if (userDetails)
            payload = {
                tab_name: CONSTANTS[selectedCard],
                user_id: userDetails.user_id,
                user_type: userDetails.role[0],
                ulb_id: selectedEnterprise?.key,
                from_date: tempStartDate ? `${tempStartDate} 00:00:00` : null,
                to_date: tempEndDate ? `${tempEndDate} 23:59:59` : null
            };


        setIsDownloading(true);
        const encodedPayload = btoa(JSON.stringify(payload));
        ServiceUtils.postRequest("ulb-csv-download", encodedPayload, true, undefined, "arraybuffer").then(
            (_response) => {

                if (_response.status === 200) {
                    if (_response?.status !== "failed" && _response?.status !== "Failed") {
                        generateFile(_response?.data)
                        setIsDownloading(false);
                    } else {
                        setIsDownloading(false);
                        alertService.error(
                            _response?.message || `Error while downloading csv`
                        );
                    }
                } else {
                    setIsDownloading(false);
                    alertService.error(
                        _response?.data?.message ||
                        _response?.message ||
                        "Internal Server Error"
                    );
                }
            }
        );
    }

    const onfetchComplaintsStatus = (item) => {
        let payload;
        if (userDetails)
            payload = {
                tab_name: CONSTANTS[selectedCard],
                user_id: userDetails.user_id,
                user_type: userDetails.role[0],
                ulb_id: item?.key,
            };

        const encodedPayload = btoa(JSON.stringify(payload));
        ServiceUtils.postRequest("complaints-status", encodedPayload).then(
            (_response) => {
                let decodedData;
                if (_response?.data) {
                    decodedData = JSON.parse(atob(_response.data));
                }

                if (_response.status === 200) {
                    // if (decodedData?.status === 'success') {
                    setComplaintsStatus(decodedData);
                    // } else {
                    //     alertService.error(decodedData?.message || `Error while complaints status`);
                    // }
                } else {
                    alertService.error(
                        decodedData?.data?.message ||
                        decodedData?.message ||
                        "Internal Server Error"
                    );
                }
            }
        );
    };

    const fetchComplaintsList = (value, date) => {
        let payload;
        console.log(calenderValue);
        let tempStartDate = date && date[0];
        let tempEndDate = date && date[1];
        if (!date && calenderValue && calenderValue[1]) {
            tempEndDate = calenderValue[1]["_i"]
            tempStartDate = calenderValue[0]["_i"]
        }
        if (userDetails)
            payload = {
                tab_name: CONSTANTS[value],
                user_id: userDetails.user_id,
                user_type: userDetails.role[0],
                ulb_id: selectedEnterprise?.key,
                from_date: tempStartDate ? `${tempStartDate} 00:00:00` : null,
                to_date: tempEndDate ? `${tempEndDate} 23:59:59` : null
            };


        setIsPageLoading(true);
        const encodedPayload = btoa(JSON.stringify(payload));
        ServiceUtils.postRequest("list-complaints", encodedPayload).then(
            (_response) => {
                let decodedData;
                if (_response?.data) {
                    decodedData = JSON.parse(atob(_response.data));
                }
                if (_response.status === 200) {
                    if (decodedData?.status === "success") {
                        setComplaintsList(decodedData);
                        setIsPageLoading(false);
                    } else {
                        alertService.error(
                            decodedData?.message || `Error while listing complaints`
                        );
                    }
                } else {
                    alertService.error(
                        decodedData?.data?.message ||
                        decodedData?.message ||
                        "Internal Server Error"
                    );
                }
            }
        );
    };

    const disabledDate = (current) => {
        // Can not select days after today
        return current && current > moment().endOf('day');
    };

    const handleDatePicker = (date, dateString) => {
        if (dateString && dateString[0].length && dateString[1].length) {
            setCalenderValue([moment(dateString[0], "YYYY-MM-DD"), moment(dateString[1], "YYYY-MM-DD")])
        }
        else {
            setCalenderValue(null)
        }
        fetchComplaintsList(selectedCard, dateString);
    };

    return (
        <div>

            {!selectedItem ?
                <>
                    <Header />
                    <Affix offsetTop={46}>
                        {!selectedEnterprise ? (
                            <div className="tabsContainer">
                                <TopNav menuConfig={MenuConfig} currentMenu="home" />
                            </div>
                        ) : (
                            <>
                                <div className="breadCrumb">
                                    <div className="path-display-container">
                                        <div className="backIcon"
                                            onClick={() => onClickBack()}>
                                            <FontAwesomeIcon
                                                icon={faCircleArrowLeft}
                                            />
                                        </div>
                                        <div
                                            className="breadCrumbLink"
                                            onClick={onClickBreadCrumb}
                                        >
                                            Dashboard
                                        </div>
                                        <div className="divider">/</div>
                                        {props.selectedState && (
                                            <>
                                                <div className="breadCrumbLink" onClick={onClickDashboard}>
                                                    {props.selectedState.title}
                                                </div>
                                                <div className="divider">/</div>
                                            </>
                                        )}
                                        {props.selectedRo && (
                                            <>
                                                <div className="breadCrumbLink" onClick={onClickDashboard}>
                                                    {props.selectedRo.title}
                                                </div>
                                                <div className="divider">/</div>
                                            </>
                                        )}
                                        <div className="breadCrumbContent">
                                            {selectedEnterprise?.title}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </Affix>

                    {isPageLoading ? (
                        <Spinner />
                    ) : (
                        <div className="contentDetails">
                            <div className="selectedCard">{`Total Complaints: ${complaintsStatus?.count_json["total_complaints"]}`}</div>
                            <Row gutter={6}>
                                {statuslist?.map((item) => {
                                    if (item !== "total_complaints")
                                        return (
                                            <Col onClick={() => onSelectCard(CONSTANTS[item])}>
                                                <Cards
                                                    icon={
                                                        <div
                                                            className={classNames("cardIcon", {
                                                                selectedCardIcon: selectedCard === CONSTANTS[item],
                                                            })}
                                                        >
                                                            <SVGIcon
                                                                icon={
                                                                    selectedCard !== CONSTANTS[item]
                                                                        ? ICON_DETAILS[item]
                                                                        : `${ICON_DETAILS[item]}Light`
                                                                }
                                                            />
                                                        </div>
                                                        // <FontAwesomeIcon
                                                        //     icon={ICON_DETAILS[item]}
                                                        //     className="iconStyle"
                                                        // />
                                                    }
                                                    count={complaintsStatus?.count_json[item].toString()}
                                                    content={CONSTANTS[item]}
                                                    selectedCard={selectedCard}
                                                    borderStyle={
                                                        selectedCard === CONSTANTS[item]
                                                            ? { borderColor: "#006988", backgroundColor: "#EBF5F8", cursor: "pointer" }
                                                            : { cursor: "pointer" }
                                                    }
                                                />
                                            </Col>
                                        );
                                })}
                            </Row>

                            <div className="selectedCard">{selectedCard.replace("_", " ")}</div>
                            <div className="">
                                <div>
                                    <div className="filter-by">Filter by Date:</div>
                                    <div className="dateFilter">
                                        <div>
                                            <RangePicker disabledDate={disabledDate} defaultValue={calenderValue} onChange={handleDatePicker} />
                                        </div>
                                        <div className="statusContainer">
                                            <div className="statusContent">
                                                <Tooltip title={CONSTANTS.RECEIVED_2_DAYS}>
                                                    {/* <Badge count={statusCount?.success} showZero color="#008000" text={<>{CONSTANTS.RECEIVED_2_DAYS} </>}> */}
                                                    <span><FontAwesomeIcon
                                                        icon={faSquare}
                                                        className="iconGreen "
                                                    />
                                                    </span>
                                                    <span>
                                                        {` : ${statusCount?.success}`}
                                                    </span>
                                                    {/* </Badge> */}
                                                </Tooltip >
                                            </div>
                                            <div className="statusContent">
                                                <Tooltip title={CONSTANTS.RECEIVED_4_DAYS}>
                                                    {/* <Badge count={statusCount?.warning} showZero color="#FFA500" text={<>{CONSTANTS.RECEIVED_4_DAYS}</>}> */}
                                                    <span><FontAwesomeIcon
                                                        icon={faSquare}
                                                        className="iconYellow "
                                                    />
                                                    </span>
                                                    <span>
                                                        {` : ${statusCount?.warning}`}
                                                    </span>
                                                </Tooltip>
                                                {/* </Badge> */}
                                            </div>
                                            <div className="statusContent">
                                                <Tooltip title={CONSTANTS.RECEIVED_MORE_4_DAYS}>
                                                    {/* <Badge count={statusCount?.error} showZero color="#FF0000" text={<>{CONSTANTS.RECEIVED_MORE_4_DAYS}</>}> */}
                                                    <span> <FontAwesomeIcon
                                                        icon={faSquare}
                                                        className="iconRed "
                                                    />
                                                    </span>
                                                    <span>
                                                        {` : ${statusCount?.error}`}
                                                    </span>
                                                    {/* </Badge> */}
                                                </Tooltip>
                                            </div>
                                            <div className="statusContent">
                                                <Tooltip title={CONSTANTS.SLA_BREACHED}>
                                                    {/* <Badge count={statusCount?.breached} showZero color="#FF0000" text={<>{CONSTANTS.SLA_BREACHED}</>}> */}
                                                    <span><FontAwesomeIcon
                                                        icon={faTriangleExclamation}
                                                        className="iconRed "
                                                    />
                                                    </span>
                                                    <span>
                                                        {` : ${statusCount?.breached}`}
                                                    </span>
                                                    {/* </Badge> */}
                                                </Tooltip>
                                            </div>
                                        </div>

                                        <div className="">
                                            <Tooltip title="Download as CSV">
                                                <Button type="primary" icon={<DownloadOutlined />} size="default" loading={isDownloading} onClick={onCsvDownload} />
                                            </Tooltip>
                                        </div>
                                    </div>
                                </div>
                                {/* <div>
                            <div className="statusDetailsHeader">Status count details</div>

                        </div> */}
                            </div>
                            <ListingTable
                                getSelectedItem={getSelectedItem}
                                dataValues={complaintsList?.data}
                                getStatusCount={getStatusCount}
                                selectedCard={selectedCard}
                            />
                        </div>
                    )
                    }
                </>
                :
                <ComplaintDetails
                    currentComplaintId={selectedItem}
                    onClickAdminDashboard={props.onClickAdminDashboard}
                    onClickStateDashboard={props.onClickStateDashboard}
                    onClickDashboard={onClickDashboard}
                    onClickBack={() => setSelectedItem("")}
                    selectedUlb={selectedEnterprise}
                    selectedRo={props.selectedRo}
                    selectedState={props.selectedState} />
            }
        </div >
    );
}
